module.exports = __webpack_public_path__ + "img/amx-12.125a26c9.webp";